import { giphyLightCharcoal } from '@giphy/js-brand'
import { ReactNode, useEffect, useState } from 'react'
import styled, { css } from 'styled-components'
import { TitleSmall } from './typography'

const Container = styled.div`
    border-bottom: 1px solid rgba(216, 216, 216, 0.15);
    display: flex;
    width: 100%;
`

const Tab = styled(TitleSmall)<{ active: boolean }>`
    color: ${({ active }) => (active ? '#fff' : giphyLightCharcoal)};
    cursor: pointer;
    height: 30px;
    margin: 0 20px 0 0;
    overflow: hidden;
    text-overflow: ellipsis;
    user-select: none;
    white-space: nowrap;

    &:last-child {
        margin-right: 0;
    }

    ${({ active }) =>
        active &&
        css`
            box-shadow: inset 0 -4px 0 0 #fff;
        `}
`

type Props = {
    labels: ReactNode[]
    onChange: (index: number) => void
}

const CreationNavigationTabs = ({ labels, onChange }: Props) => {
    const [activeIndex, setActiveIndex] = useState<number>(0)

    useEffect(() => {
        onChange(activeIndex)
    }, [activeIndex])

    return (
        <Container>
            {labels.map((label, i) => (
                <Tab key={`navigationtab-${i}`} active={activeIndex === i} onClick={() => setActiveIndex(i)}>
                    {label}
                </Tab>
            ))}
        </Container>
    )
}

export default CreationNavigationTabs
